var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('iframe',{staticClass:"pdfcon",attrs:{"src":_vm.url,"frameborder":"0"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }